<section class="placeholder">
  <mat-icon>construction</mat-icon>
  <h1>{{ title() }}</h1>
  <p>This section is coming soon.</p>
</section>
